

export const strings = {
    methods: {
        decode(utftext) {
            var string = "";

            var i = 0;

            var c = 0;
            var c1 = 0;
            var c2 = 0;
            var c3 = 0;

            while (i < utftext.length) {
                c = utftext.charCodeAt(i);
                var car = utftext[i];



                if (
                    c < 128 ||
                    c == 233 ||
                    c == 225 ||
                    c == 237 ||
                    c == 243 ||
                    c == 250 ||
                    c == 241 ||
                    c == 193 ||
                    c == 201 ||
                    c == 205 ||
                    c == 211 ||
                    c == 218 ||
                    c == 191 ||
                    c == 252 ||
                    c == 220
                ) {
                    if (
                        c == 233 ||
                        c == 225 ||
                        c == 237 ||
                        c == 243 ||
                        c == 250 ||
                        c == 241 ||
                        c == 193 ||
                        c == 201 ||
                        c == 205 ||
                        c == 211 ||
                        c == 218 ||
                        c == 191 ||
                        c == 252 ||
                        c == 220

                    ) {
                        string += car;
                    } else {
                        string += String.fromCharCode(c);
                    }

                    i++;
                } else if (c > 191 && c < 224) {
                    c2 = utftext.charCodeAt(i + 1);

                    string += String.fromCharCode(((c & 31) << 6) | (c2 & 63));

                    i += 2;
                } else {
                    c2 = utftext.charCodeAt(i + 1);

                    c3 = utftext.charCodeAt(i + 2);

                    string += String.fromCharCode(
                        ((c & 15) << 12) | ((c2 & 63) << 6) | (c3 & 63)
                    );

                    i += 3;
                }
            }

            return string;
        },
        convertString(str) {

            str = _.replace(str, /\\n,/g, "<br />");
            str = _.replace(str, /\\n/g, "<br />");
            str = _.replace(str, /\\/g, "");
            str = _.replace(str, /\\|\//g, '');

            var d = this.decode(str);



            return d;
        },
        convertStringAndTrim(str) {

            str = _.replace(str, /\\n,/g, "<br />");
            str = _.replace(str, /\\n/g, "<br />");
            str = _.replace(str, /\\/g, "");
            str = _.replace(str, /\\|\//g, '');

            var d = this.decode(str);

            var length = 50;
            var ns = d.substring(0, length);
            if (d.length > 55) {
                return ns + '...';
            } else {
                return ns;
            }

        }
    }
};